module.exports = __webpack_public_path__ + "img/blood-bag.4cb4f3a7.svg";